import { render, staticRenderFns } from "./RestartPage.vue?vue&type=template&id=425bf3fa&scoped=true"
import script from "./RestartPage.vue?vue&type=script&lang=js"
export * from "./RestartPage.vue?vue&type=script&lang=js"
import style0 from "./RestartPage.vue?vue&type=style&index=0&id=425bf3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425bf3fa",
  null
  
)

export default component.exports